import React from 'react';

import AttachmentField from './AttachmentField';
import Checkbox from './Checkbox';
import CheckboxGroup from './CheckboxGroup';
import ChipsInput from './ChipsInput';
import Const from './Const';
import CustomMetricCalculator from './CustomMetricCalculator';
import DatePicker from './DatePicker';
import DateRangePicker from './DateRangePicker';
import FormHierarchyField from './FormHierarchyField';
import MarkdownRichText from './MarkdownRichText';
import MentionsRichText from './MentionsRichText';
import MonthPicker from './MonthPicker';
import MonthRangePicker from './MonthRangePicker';
import MultiSelect from './MultiSelect';
import RadioGroup from './RadioGroup';
import RatingField from './RatingField';
import Select from './Select';
import Switch from './Switch';
import TextField from './TextField';
import TimeInput from './TimeInput';
import ToggleButtonGroup from './ToggleButtonGroup';

export default class FormField extends React.Component {
  static MultiSelect = MultiSelect;
  static RadioGroup = RadioGroup;
  static AttachmentField = AttachmentField;
  static Select = Select;
  static Checkbox = Checkbox;
  static CheckboxGroup = CheckboxGroup;
  static ChipsInput = ChipsInput;
  static TextField = TextField;
  static DatePicker = DatePicker;
  static DateRangePicker = DateRangePicker;
  static MonthPicker = MonthPicker;
  static MonthRangePicker = MonthRangePicker;
  static CustomMetricCalculator = CustomMetricCalculator;
  static Const = Const;
  static TimeInput = TimeInput;
  static RatingField = RatingField;
  static ToggleButtonGroup = ToggleButtonGroup;
  static Switch = Switch;
  static MarkdownRichText = MarkdownRichText;
  static MentionsRichText = MentionsRichText;
  render() {
    const { children, ...props } = this.props;
    return <FormHierarchyField {...props}>{children}</FormHierarchyField>;
  }
}
